export default __webpack_public_path__ + "static/media/a011-general2024-example4.86124dd0.png";